import React, { useEffect, useState } from 'react'
import { Form, Input, Select, Row, Col, Button, message, Spin, Typography } from 'antd'
import { getUser } from '../../../utils/auth'
import { useForm } from 'antd/es/form/Form'
import { IdcardOutlined, ShopOutlined } from '@ant-design/icons'
import { SingleImageUpload } from '../../../components/ImageUpload'
import api from '../../../api/axios'
import { useVendor } from '../VendorstartForm/VendorStore'
const { Text } = Typography;

const sectionStyle = {
    background: 'var(--qk-card-bg)',
    borderRadius: 16,
    padding: '24px 28px',
    marginBottom: 20,
    border: '1px solid var(--qk-border)',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
};

const sectionHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 16,
};

const iconBoxStyle = (color) => ({
    width: 36,
    height: 36,
    borderRadius: 10,
    background: color + '14',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    color: color,
});


const Settings = () => {
    let { regions, setRegions, districts, setDistricts, mybusiness, setMyBusiness, mainImage, setMainImage } = useVendor();
    let [sdistricts, setSDistricts] = useState([]);
    let [loading, setLoading] = useState(false);
    let [submitting, setSubmitting] = useState(false);

    let user = getUser();
    let [form] = useForm();

    useEffect(() => {
        setLoading(true);
        Promise.all([
            api.get("/sdata"),
            api.get('/businesses/my/' + user.id)
        ]).then(([sdataRes, bizRes]) => {
            setRegions(sdataRes.data.regions || []);
            setDistricts(sdataRes.data.districts || []);
            setMyBusiness(bizRes.data.data);
            setMainImage(bizRes.data.data.main_image);
            localStorage.setItem('mybusiness', JSON.stringify(bizRes.data.data));
        }).catch(err => {
            console.error("Data load error:", err);
            message.error("Ma'lumotlarni yuklashda xatolik yuz berdi");
        }).finally(() => setLoading(false));
    }, [user.id]);

    useEffect(() => {
        if (mybusiness) {
            setSDistricts(districts.filter(d => d.regions_id === mybusiness.districts_regions_id));
            form.setFieldsValue(mybusiness);
        }
    }, [mybusiness, districts, form]);

    let handleRegionChange = (value) => {
        setSDistricts(districts.filter(d => d.regions_id === value));
        form.setFieldValue('districts_id', undefined);
    };

    let handleSubmit = (values) => {
        setSubmitting(true);
        values.main_image = mainImage;
        api.post('/businesses', values).then(res => {
            message.success("Korxona ma'lumotlari muvaffaqiyatli saqlandi!");
            setMyBusiness(res.data.data || res.data);
            localStorage.setItem('mybusiness', JSON.stringify(res.data.data || res.data));
            localStorage.setItem('user', JSON.stringify(res.data.user));
            window.location.reload();
        }).catch(err => {
            console.error(err);
            message.error("Saqlashda xatolik yuz berdi");
        }).finally(() => setSubmitting(false));
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
                <Spin size="large" tip="Ma'lumotlar yuklanmoqda..." />
            </div>
        );
    }
    return (
        <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '20px 4px 0', scrollbarWidth: 'thin' }}>
            <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>

                {/* === Korxona ma'lumotlari === */}
                <div style={sectionStyle}>
                    <div style={sectionHeaderStyle}>
                        <div style={iconBoxStyle('#667eea')}><IdcardOutlined /></div>
                        <div>
                            <Text strong style={{ fontSize: 15 }}>Korxona ma'lumotlari</Text>
                            <br />
                            <Text type="secondary" style={{ fontSize: 12 }}>Rasmiy ma'lumotlarni kiriting</Text>
                        </div>
                    </div>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item rules={[{ required: true, message: 'STIR raqamini kiriting' }]} name="stir" label="Soliq STIR raqami">
                                <Input type="number" placeholder="123456789" size="large" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item rules={[{ required: true, message: 'Nomini kiriting' }]} name="name" label="Korxona yoki brend nomi">
                                <Input placeholder="Masalan: Quvonchli Kun" size="large" prefix={<ShopOutlined style={{ color: '#bbb' }} />} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={6}>
                            <Form.Item rules={[{ required: true, message: 'Viloyatni tanlang' }]} name="districts_regions_id" label="Viloyat">
                                <Select
                                    getPopupContainer={t => t.parentNode}
                                    placeholder="Viloyatni tanlang"
                                    size="large"
                                    showSearch
                                    optionFilterProp="label"
                                    options={regions.map(r => ({ label: r.nameUz, value: r.id }))}
                                    onChange={handleRegionChange}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item rules={[{ required: true, message: 'Tumanni tanlang' }]} name="districts_id" label="Tuman">
                                <Select
                                    getPopupContainer={t => t.parentNode}
                                    placeholder={sdistricts.length ? "Tumanni tanlang" : "Avval viloyatni tanlang"}
                                    size="large"
                                    showSearch
                                    optionFilterProp="label"
                                    disabled={!sdistricts.length}
                                    options={sdistricts.map(d => ({ label: d.nameUz, value: d.id }))}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item rules={[{ required: true, message: 'Manzilni kiriting' }]} name="address" label="Manzil">
                                <Input placeholder="Ko'cha, uy raqami" size="large" />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item rules={[{ required: true, message: 'Telefon raqamini kiriting' }]} name="phone" label="Telefon raqami">
                                <Input prefix="+998" placeholder="901234567" size="large" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="main_image" label="Asosiy rasm yoki logotip">
                                <SingleImageUpload
                                    file={mainImage}
                                    setFile={(data) => {
                                        setMainImage(data);
                                        form.setFieldValue('main_image', data);
                                    }}
                                    width={140}
                                    height={140}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                {/* === Submit === */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: 8 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        loading={submitting}
                        style={{
                            borderRadius: 12,
                            height: 48,
                            paddingInline: 32,
                            fontWeight: 600,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            border: 'none',
                            boxShadow: '0 4px 14px rgba(102,126,234,0.4)',
                        }}
                    >
                        Saqlash
                    </Button>
                </div>
            </Form>
        </div>
    )
}

export default Settings